import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
const TableTab3 = ({ setselected_tax_item_data, selected_tax_item_data }) => {
  const createNewRow = () => ({
    item_tax_template: "",
    tax_category: "",
    valid_from: "",
    minimum_net_rate: "",
    maximum_net_rate: "",
  });

  const tableRef = useRef();
  const [rowsPerPage] = useState(10);

  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([createNewRow()]);
  const [selectedRows, setSelectedRows] = useState([]);
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  useEffect(() => {
    setRows(selected_tax_item_data);
  }, [selected_tax_item_data]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };

  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];

    // Ensure item exists
    if (!updatedRows[index].item) {
      updatedRows[index].item = {};
    }

    updatedRows[index].item[field] = value;

    setRows(updatedRows);
    setselected_tax_item_data(updatedRows);
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    setselected_tax_item_data(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {["S.No",  "Item Tax Template",
              "Tax Category",
              "Valid From",
              "Minimum Net Rate",
              "Maximum Net Rate",].map(
              (title, i) => {
                const isIcon = typeof title !== "string";
                const defaultWidths = {
                  "S.No": "54px",
                  "Item Tax Template": "202px",
                "Tax Category": "202px",
                "Valid From": "202px",
                "Minimum Net Rate": "202px",
                "Maximum Net Rate": "202px",
                };

                return (
                  <th
                    key={i}
                    style={{
                      fontSize: "7px",
                      position: "relative",
                      textAlign:
                        title === "Action" ||
                        title === "S.No" ||
                        title === "isIcon"
                          ? "center"
                        : "center",

                      width:
                        typeof title === "string"
                          ? defaultWidths[title] || "303px"
                          : "303px",
                      minWidth:
                        typeof title === "string"
                          ? defaultWidths[title] || "303px"
                          : "303px",
                    }}
                  >
                    {title === "Action" ? (
                      <input
                        type="checkbox"
                        className="form-check-input"
                        style={{
                          backgroundColor: isAllSelected ? "#270b79" : "",
                          borderColor: isAllSelected ? "#270b79" : "",
                          fontSize: "15px",
                        }}
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                      />
                    ) : isIcon ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {title}
                      </div>
                    ) : (
                      title
                    )}
                  </th>
                );
              }
            )}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                <td
                  style={{
                    textAlign: "center",
                    fontSize: '0.8rem',textAlign: "center",
                    padding: "0.5rem",
                  }}
                >
                  {globalIndex + 1}
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign: "center" }}
                    readOnly
                    value={row.item_tax_template}
                  />
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign: "center" }}
                    readOnly
                    value={row.tax_category}
                  />
                </td>
                <td className="p-0">
                  <input
                    type="date"
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign: "center" }}
                    readOnly
                    value={row.valid_from}
                  />
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign: "center" }}
                    readOnly
                    value={row.minimum_net_rate}
                  />
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign: "center" }}
                    readOnly
                    value={row.maximum_net_rate}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div
        className="d-flex pb-2  justify-content-between align-items-center"
        style={{ marginTop: "12px", marginBottom: "16px" }}
      >
        <div
          className={`${
            rows.length < 11 ? "d-none" : "d-flex"
          } align-items-center centerpagination`}
          style={{ gap: "5px" }}
        >
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
            Showing {indexOfFirstRow + 1} to{" "}
            {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default TableTab3;
